import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';
import List from './List';
import Add from './Add';
import PipelineDetail from './PipelineDetail';
import RunHistory from './RunHistory';
import RunDetail from './RunDetail';

// Wave 3 (deploy-pipelines-wizard) route registry — mirrors appInstanceRoutes. Each route
// is wrapped in AllowedAccess so a user without the matching PIPELINE_* permission is
// blocked at the route level (AC-1), not just hidden in the nav. Aggregated into the app
// router in pages/index.js.
export const pipelineRoutes = [
	{
		permittedRole: RoutePermittedRole.User,
		path: [ROUTE_STRING.PIPELINE.LIST],
		element: (
			<AllowedAccess permissionIds={[AuthorizePermission.PIPELINE_READ]}>
				<List />
			</AllowedAccess>
		)
	},
	{
		permittedRole: RoutePermittedRole.User,
		path: [ROUTE_STRING.PIPELINE.ADD],
		element: (
			<AllowedAccess permissionIds={[AuthorizePermission.PIPELINE_CREATE]}>
				<Add />
			</AllowedAccess>
		)
	},
	{
		// AC-14 — VIEW now lands on the dedicated pipeline detail page (was RunHistory).
		// This route map was the ONLY place conflating VIEW == run history (pre-impl review
		// confirmed); nothing else navigates to VIEW today, so this is a one-line split.
		permittedRole: RoutePermittedRole.User,
		path: [ROUTE_STRING.PIPELINE.VIEW],
		element: (
			<AllowedAccess permissionIds={[AuthorizePermission.PIPELINE_READ]}>
				<PipelineDetail />
			</AllowedAccess>
		)
	},
	{
		// RUNS keeps its current RunHistory behaviour unchanged (Out of scope: retiring/
		// repointing RUNS or RUN_VIEW).
		permittedRole: RoutePermittedRole.User,
		path: [ROUTE_STRING.PIPELINE.RUNS],
		element: (
			<AllowedAccess permissionIds={[AuthorizePermission.PIPELINE_READ]}>
				<RunHistory />
			</AllowedAccess>
		)
	},
	{
		permittedRole: RoutePermittedRole.User,
		path: [ROUTE_STRING.PIPELINE.RUN_VIEW],
		element: (
			<AllowedAccess permissionIds={[AuthorizePermission.PIPELINE_READ]}>
				<RunDetail />
			</AllowedAccess>
		)
	}
];
